export default __webpack_public_path__ + "static/media/realisation-of-charged-securities.7f7854b0.jpg";